// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 8128) return "static/chunks/8128-096eca0469ffacd3.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9066 ? "dc112a36" : chunkId) + "." + {"6847":"31dfe19fd74ed41d","7853":"f836a196c352a3cb","9066":"137e690a63e0bd72"}[chunkId] + ".js";
};